export const getConcatenatedKey = (
  inputs: Array<number | string | null | undefined>,
  fixedLengthIntervals = 10,
) => {
  return inputs
    .map((input) =>
      String(input ? input : '')
        .padStart(fixedLengthIntervals, '0')
        .slice(0, fixedLengthIntervals),
    )
    .join('-');
};
